import { Text } from "pixi.js";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";
import { PiggyViewHeaderComponent } from "./PiggyViewHeaderComponent";
import { PiggyViewTextStyle } from "../textstyle/PiggyViewTextStyle";

export class PiggyViewUnlockedHeaderComponent extends PiggyViewHeaderComponent {
    private static readonly MIDDLE_TEXT = 'AMAZING JOB!';
    private static readonly BOTTOM_TEXT = "YOU'VE UNLOCKED YOUR PIGGY!";

    private middleText: Text;
    private bottomText: Text;

    public constructor(piggyResources: PiggyResourcePackage) {
        super(piggyResources);
        this.build();
        this.layout();
    }

    private build(): void {
        this.middleText = new Text(PiggyViewUnlockedHeaderComponent.MIDDLE_TEXT + "", new MiddleTextStyle());
        this.middleText.skew.x = -0.087;
        this.middleText.angle = -5;
        this.bottomText = new Text(PiggyViewUnlockedHeaderComponent.BOTTOM_TEXT + "", new BottomTextStyle());
        this.bottomText.skew.x = -0.087;
        this.bottomText.angle = -5;
        this.addChild(this.middleText, this.bottomText);
    }

    private layout(): void {
        this.middleText.position.set(this.background.width * 0.5 - this.middleText.width * 0.5, 149);
        this.bottomText.position.set(this.background.width * 0.5 - this.bottomText.width * 0.5, 279);
    }
}

class MiddleTextStyle extends PiggyViewTextStyle {
    public constructor() {
        super();
        this.fontSize = 128;
        this.letterSpacing = 0.6;
    }
}

class BottomTextStyle extends PiggyViewTextStyle {
    public constructor() {
        super();
        this.fontSize = 73;
    }
}
